<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>{{ $t(`message.slideEightTitle`) }}</h1>
        <br />
        <h2>
          {{ $t(`message.slideEightSubTitle`) }}
        </h2>
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideEightRadioGroupQuestion`) }}
        </span>
        <v-radio-group
          v-model="existingTransportationSystem"
          @change="
            setEx2({
              field: `existingTransportationSystem`,
              text: existingTransportationSystem
            })
          "
          row
          :style="
            $vuetify.breakpoint.xs ? `margin-left: 30%` : `margin-left: 37%`
          "
        >
          <v-radio
            :label="$t(`message.slideEightRadioGroupYesLabel`)"
            value="yes"
          ></v-radio>
          <v-radio
            :label="$t(`message.slideEightRadioGroupNoLabel`)"
            value="no"
          ></v-radio>
        </v-radio-group>
      </v-col>

      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideEightSelectOneQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideEightSelectOneLabel`)"
          v-model="typesOfModes"
          item-text="label"
          item-value="value"
          @change="
            setEx2({
              field: `typesOfModes`,
              text: typesOfModes
            })
          "
          :items="$t(`message.slideEightSelectOneChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ typesOfModes.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideEightSelectTwoQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideEightSelectTwoLabel`)"
          v-model="typesOfTripPurposes"
          item-text="label"
          item-value="value"
          @change="
            setEx2({
              field: `typesOfTripPurposes`,
              text: typesOfTripPurposes
            })
          "
          :items="$t(`message.slideEightSelectTwoChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ typesOfTripPurposes.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideEightSelectThreeQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideEightSelectThreeLabel`)"
          v-model="typesOfUsers"
          item-text="label"
          item-value="value"
          @change="
            setEx2({
              field: `typesOfUsers`,
              text: typesOfUsers
            })
          "
          :items="$t(`message.slideEightSelectThreeChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ typesOfUsers.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  data() {
    return {
      existingTransportationSystem: "",
      typesOfModes: [],
      typesOfTripPurposes: [],
      typesOfUsers: [],
      audio: null,
      newSlideNumber: null
    };
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  },
  computed: {
    ...mapState("response", ["finalPayload"]),
    colSize() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "6";
    },
    yesNo() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 2;
    }
  },
  watch: {
    "$i18n.locale": function() {
      if (this.newSlideNumber === 7) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(7);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      if (current !== 7) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  methods: {
    ...mapActions("response", ["setEx2"])
  }
};
</script>
